import { Controller } from "@hotwired/stimulus";
import { FetchRequest } from '@rails/request.js'

// Connects to data-controller="clickable-element"
export default class extends Controller {
  static values = {
    withCurrentParams: { type: Boolean, default: false },
    extraParams: { type: Object, default: {} },
    turboDisabled: { type: Boolean, default: false },
  };

  openLink(event) {
    // Wenn element ein Link oder Formular Submit Button ist -> Nichts machen
    if (event.target.closest("A") !== null || event.target.closest("button[type='submit']") !== null || event.target.closest(".clickable-element-execption") !== null) {
      return
    }

    // Link öffnen
    const shouldOpenInNewTab = event.metaKey || event.ctrlKey || event.shiftKey;
    if (shouldOpenInNewTab) {
      window.open(this.url, "_blank");
    } else if (this.turboDisabledValue) {
      location.href = this.url;
    } else {
      const options = event.params.visitOptions || {}
      Turbo.visit(this.url, options);
    }
  }

  async makeRequest(event) {
    // Wenn element ein Link oder Formular Submit Button ist -> Nichts machen
    if (event.target.closest("A") !== null || event.target.closest("button[type='submit']") !== null || event.target.closest(".clickable-element-execption") !== null) {
      return
    }

    const body = this.element.dataset.body || {}
    const method = (this.element.dataset.method || "GET").toUpperCase()
    const responseKind = this.element.dataset.responseKind || "turbo-stream"

    const options = method === "GET" ? { responseKind } : { body, responseKind }
    const request = new FetchRequest(method, this.url, options)
    const response = await request.perform()
    if (response.redirected) {
      Turbo.visit(new URL(response.response.url.toString(), document.baseURI))
    } else {
      this.dispatch("requestCompleted", { detail: { request } })
    }

    this.dispatch("requestFinished", { detail: { request } })
  }

  get url() {
    let url = this.element.dataset.url
    const params = new URLSearchParams()

    // Extra Parameter anhängen
    if (this.hasExtraParamsValue && Object.keys(this.extraParamsValue).length > 0) {
      const extraParams = new URLSearchParams(this.extraParamsValue)
      for (const [key, value] of extraParams) {
        params.set(key, value)
      }
    }

    // Aktuelle Parameter anhängen
    if (this.withCurrentParamsValue) {
      const currentParams = new URLSearchParams(window.location.search)
      for (const [key, value] of currentParams) {
        params.set(key, value)
      }
    }

    // Neuen URL zusammenbauen
    if (params.toString()) {
      const separator = url.includes("?") ? "&" : "?"
      url += `${separator}${params.toString()}`
    }

    return url
  }
}
